import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PartenaireSection from "../components/partenaires/HeroSection";
import IntroPartenairesSection from "../components/partenaires/IntroSection";
import MapPartenaires from "../components/partenaires/MapPartenaires";
import FormulaireSection from "../components/partenaires/FormulaireSection";
import { useSites } from "../context/SitesContext";
import { useTranslation } from "react-i18next";

const Partenaire = () => {
  const { t } = useTranslation("pages/Partenaire");
  const { sites, loading } = useSites();

  return (
    <>
      <Navbar />
      <Box sx={{ height: "50px" }} />
      <PartenaireSection />
      <IntroPartenairesSection />

      {loading ? (
        <Box sx={{ py: 10, display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="success" />
          <Typography sx={{ mt: 2 }}>{t("loading")}</Typography>
        </Box>
      ) : (
        <MapPartenaires rawSites={sites} />
      )}

      <div id="formulaire">
        <FormulaireSection />
      </div>

      <Footer />
    </>
  );
};

export default Partenaire;